<template>
	<client-only>
		<div class="results-width-no-headvisual-layout">
			<div class="page--wrapper">
				<div class="container">
					<div class="pt-4 pb-4 result-table-wrapper">
						<div class="result-table-overview">
							<div class="result-table-body h-100">
								<div v-if="loadingStatus" class="loading-container">
									<div class="loading"></div>
									Daten werden geladen...
								</div>
							</div>
							<template>
								<!--Row Starts-->
								<div class="result-table-row">
									<!--Text header Job description -->
									<div class="result-table-cell flex-basis-100 border-bottom-0">
										<div class="center-wrapper">
											<header class="mb-0 result-table-item-header-job">
												{{ jobDetails.jobTitel }}
											</header>
										</div>
									</div>
								</div>
								<!--Row Ends-->

								<!--Row Starts-->
								<div class="result-table-row">
									<!--Text header Job description -->
									<div class="result-table-cell flex-basis-100 pb-0">
										<div class="center-wrapper">
											<p class="shortread">
												{{ UpdatedOn }}
												{{
													jobDetails.aktualisiertAm
													| convert
												}}
											</p>
										</div>
									</div>
									<!--Action Buttons -->
									<div class="result-table-cell flex-basis-10 pb-0">
										<div class="result-table-action-buttons action-cell">
											<div class="col">
												<nuxt-link exact to="/bewerber/jobsuche/jobboerse" class="btn action">
													<font-awesome-icon :icon="[
																'fal',
																'search',
															]" />
													<span class="button-text">
														{{ ButtonBack }}
													</span>
												</nuxt-link>
											</div>
											<client-only>
												<div class="col">
													<button class="btn action bookmarks" :class="{ 'on': isAddClass }"
														@click="bookmarkAdd">
														<i class="icon-bookmarks"></i>
														<span class="button-text"></span>
													</button>
												</div>
											</client-only>

											<div class="col">
												<nuxt-link to="/bewerber/jobsuche/jobboerse/jobboerse-merkliste"
													class="btn action">
													<font-awesome-icon :icon="[
														'fal',
														'clipboard-list',
													]" />
													<span class="button-text">
														{{ ButtonList }}
													</span>
												</nuxt-link>
											</div>
										</div>
									</div>
								</div>
								<!--Row Ends-->

								<!--Row Starts-->
								<div class="result-table-row sm-flex-column result-table-expand-md">
									<!--List -->
									<div class="result-table-cell flex-basis-75 sm-no-border">
										<div class="center-wrapper">
											<dl class="mb-0 row">
												<dt class="col-6 col-lg-3">
													<span v-if="jobDetails.referenzNummer">
														{{ ReferenceNumber }}
													</span>
												</dt>
												<dd  class="col-6 col-lg-9">
													<span v-if="jobDetails.referenzNummer">
														{{
															jobDetails.referenzNummer
														}}
													</span>
												</dd>

												<dt class="col-6 col-lg-3">
													{{ PlaceOfWork }}
												</dt>
												<dd class="col-6 col-lg-9">
													<span v-for="(
															el, jobOrte
														) in jobDetails.jobOrte" :key="jobOrte">
														{{ el.jobOrt }} <br />
														{{ el.jobPlz }}
														{{ el.jobRegion }}
													</span>
												</dd>

												<dt class="col-6 col-lg-3">
													<span v-if="jobDetails.DrivingLicence">
														{{ DrivingLicence }}
													</span>
												</dt>
												<dd class="col-6 col-lg-9">
													<div v-if="jobDetails.DrivingLicence" class="json-html-list w-60" v-html="jobDetails.fuehrerschein
														"></div>
												</dd>

												<dt class="col-6 col-lg-3">
													{{ StartWorking }}
												</dt>
												<dd class="col-6 col-lg-9">
													{{
														jobDetails.arbeitsbeginn
														| convert
													}}
												</dd>

												<dt class="col-6 col-lg-3">
													{{ OpenPositions }}
												</dt>
												<dd class="col-6 col-lg-9">
													{{
														jobDetails.anzahlStellen
													}}
												</dd>
											</dl>
										</div>
									</div>

									<!--Button action Apply -->
									<div class="result-table-cell flex-basis-25">
										<div class="center-wrapper">
											<a :href="getHRLink" class="pl-4 pr-4 btn btn-tertiary w-100 btn-apply" id="button-bewerben-stellenazeige"
												target="_blank">
												{{ ButtonApply }}
											</a>
										</div>
									</div>
								</div>
								<!--Row Ends-->

								<!--Row Starts-->
								<div class="result-table-row sm-flex-column result-table-expand-md">
									<!--Text header Company presentation -->
									<div class="result-table-cell flex-basis-50" v-b-toggle.company-presentation>
										<div class="center-wrapper">
											<header class="mb-0 result-table-item-header">
												{{ CompanyPresentation }}
											</header>
										</div>
									</div>

									<!--Text Company presentation -->
									<b-collapse visible is-nav class="result-table-cell flex-basis-50 action-cell"
										id="company-presentation">
										<div class="center-wrapper">
											<p class="p-0" v-html="jobDetails.unternehmensvorstellung"></p>
										</div>
									</b-collapse>
								</div>
								<!--Row Ends-->

								<!--Row Starts-->
								<div class="result-table-row sm-flex-column result-table-expand-md">
									<!--Text header We are looking for -->
									<div class="result-table-cell flex-basis-50" v-b-toggle.looking-for>
										<div class="center-wrapper">
											<header class="mb-0 result-table-item-header">
												{{ WeareLookingFor }}
											</header>
										</div>
									</div>

									<!--Text We are looking for -->
									<b-collapse visible is-nav class="result-table-cell flex-basis-50 action-cell"
										id="looking-for">
										<div class="center-wrapper">
											<p class="p-0">
												{{ jobDetails.wirSuchen }}
											</p>
										</div>
									</b-collapse>
								</div>
								<!--Row Ends-->

								 <!--Row Starts-->
							<div class="result-table-row sm-flex-column result-table-expand-md">
								<!--Text header requirements -->
								<div
									class="result-table-cell flex-basis-50"
									v-b-toggle.requirements
								>
									<div class="center-wrapper">
										<header class="result-table-item-header mb-0">
											{{ Requirements }}
										</header>
									</div>
								</div>

								<!--List -->
								<b-collapse
									visible is-nav
									class="result-table-cell flex-basis-50 action-cell"
									id="requirements"
								>
									<div class="center-wrapper">
										<div
											class="json-html-list"
											v-html="jobDetails.faehigkeiten"
										>
										</div>
									</div>
								</b-collapse>
							</div>
							<!--Row Ends-->

								<!--Row Starts-->
								<div class="result-table-row sm-flex-column result-table-expand-md">
									<!--Text header Your tasks -->
									<div class="result-table-cell flex-basis-50" v-b-toggle.your-tasks>
										<div class="center-wrapper">
											<header class="mb-0 result-table-item-header">
												{{ YourTask }}
											</header>
										</div>
									</div>

									<!--List -->
									<b-collapse visible is-nav class="result-table-cell flex-basis-50 action-cell"
										id="your-tasks">
										<div class="center-wrapper">
											<div class="json-html-list" v-html="jobDetails.ihreAufgaben"></div>
										</div>
									</b-collapse>
								</div>
								<!--Row Ends-->

								<!--Row Starts-->
								<div class="result-table-row sm-flex-column result-table-expand-md"
     v-if="jobDetails.zusaetzlicheInfos && jobDetails.zusaetzlicheInfos.trim() !== '<ul><li></li></ul>'">
									<!--Text header Additional information -->
									<div class="result-table-cell flex-basis-50" v-b-toggle.additional-information>
										<div class="center-wrapper">
											<header class="mb-0 result-table-item-header">
												{{ AdditionalInformation }}
											</header>
										</div>
									</div>

									<!--List -->
									<b-collapse visible is-nav class="result-table-cell flex-basis-50 action-cell"
										id="additional-information">
										<div class="center-wrapper">
											<div class="json-html-list" v-html="jobDetails.zusaetzlicheInfos
												"></div>
										</div>
									</b-collapse>
								</div>
								<!--Row Ends-->

								<!--Row Starts-->
								<div class="result-table-row sm-flex-column result-table-expand-md">
									<!--Text header Our offer -->
									<div class="result-table-cell flex-basis-50" v-b-toggle.our-offer>
										<div class="center-wrapper">
											<header class="mb-0 result-table-item-header">
												{{ OurOffer }}
											</header>
										</div>
									</div>

									<!--Text Our offer -->
									<b-collapse visible is-nav class="result-table-cell flex-basis-50 action-cell"
										id="our-offer">
										<div class="center-wrapper">
											<div class="json-html-list" v-html="jobDetails.unserAngebot"></div>
										</div>
									</b-collapse>
								</div>
								<!--Row Ends-->
							</template>
						</div>

						<ResultsOverviewFooter />
					</div>
				</div>
			</div>
		</div>
	</client-only>
</template>

<script>
import { mapState } from 'vuex'
import ResultsOverviewFooter from '~/components/organisms/jobmarket/footer/ResultsOverviewFooter'
import HeadvisualStatic from '~/components/organisms/hero/HeadvisualStatic'

export default {
	name: 'StellenangebotId',
	layout: 'default',
	components: {
		ResultsOverviewFooter,
		HeadvisualStatic,
	},
	head() {
		return {
			title: this.jobDetails.jobTitel,
		}
	},
	data() {
		return {
			jobDetails: {}, // selected job offer details
			stellenangebotId: this.$route.params.stellenangebotId,
			tempbookmark: [],
			isAddClass: false,
			UpdatedOn: 'Aktualisiert am',
			ReferenceNumber: 'Referenznummer',
			PlaceOfWork: 'Arbeitsort',
			DrivingLicence: 'Führerschein',
			StartWorking: 'Arbeitsbeginn',
			OpenPositions: 'Anzahl der offener Stellen',
			CompanyPresentation: 'Unternehmensvorstellung',
			WeareLookingFor: 'Wir suchen',
			Requirements: 'Anforderungen',
			YourTask: 'Deine Aufgaben',
			AdditionalInformation: 'Zusätzliche Informationen',
			OurOffer: 'Unser Angebot',
			Finally: 'Zum Schluss',
			Logo: '/fileadmin/user_upload/isd-logo.png',
			StaticList: [
				{ li: '	Unbefristetes Arbeitsverhältnis' },
				{ li: 'Eigenverantwortliches Arbeiten' },
				{ li: 'Sorgfältige Einarbeitung' },
			],
			Button: 'Merken',
			ButtonList: 'Merkliste',
			ButtonBack: 'Jobsuche',
			ButtonApply: 'Auf diese Stelle bewerben',
		}
	},
	jsonld() {
		return {
			'@context': 'https://schema.org/',
			'@type': 'JobPosting',
			title: this.jobDetails.jobTitel,
			description: this.jobDetails.wirSuchen,
			datePosted: this.jobDetails.aktualisiertAm,
			StartDate: this.jobDetails.arbeitsbeginn,
			employmentType: this.jobDetails.jobTitel,
			hiringOrganization: {
				'@context': 'https://schema.org',
				'@type': 'Organization',
				name: 'ISD Immobilien Service Deutschland GmbH & Co. KG',
				// "sameAs" : process.env.NUXT_HOST,
				// "logo" : `${process.env.NUXT_HOST}fileadmin/user_upload/isd-logo.png`
			},
			jobLocation: {
				'@type': 'Place',
				address: {
					'@type': 'PostalAddress',
					addressLocality: this.jobOrt,
					addressRegion: this.jobRegion,
					postalCode: this.jobPlz,
					addressCountry: 'DE',
				},
			},
		}
	},
	filters: {
		convert: function (value) {
			if (!value) return ''
			value = value.split(/-|T/)
			return `${value[2]}.${value[1]}.${value[0]}`
		},
	},
	computed: {
		...mapState(['subsidiary', 'datajobs']),
		itemSubsidiary() {
			return this.$store.state.subsidiary.find((item) => item.plz)
		},
		loadingStatus() {
			return this.$store.getters.loadingStatus
		},
		itemBookmark() {
			return (this.jobDetails = this.datajobs.find(
				(j) => j.stellenangebotId === this.stellenangebotId
			))
		},
		getHRLink() {
			const pattern = /(?<!hr\d*)\d+/g;

			const jobId = this.stellenangebotId.match(pattern);
			return `https://personaintern.hr4you.org/job/apply/${jobId}`
		}
	},
	async mounted() {
		await this.$store.dispatch('createDataJobs')
		this.jobDetails = this.datajobs.find(
			(j) => j.stellenangebotId === this.stellenangebotId
		)
		this.$store.dispatch('selectJobOffer', this.stellenangebotId)
		this.jobLocation()
	},
	methods: {
		jobLocation: function () {
			this.jobDetails.jobOrte.forEach((nObj) => {
				let addressLocality = nObj.jobOrt
				let addressRegion = nObj.jobRegion
				let postalCode = nObj.jobPlz
				this.jobOrt = addressLocality
				this.jobRegion = addressRegion
				this.jobPlz = postalCode
			})
		},
		bookmarkAdd() {
			let item = this.itemBookmark
			item = {
				...item,
			}
			this.tempbookmark.push(item)
			this.$store.commit('addToBookmark', { ...item })
			this.isAddClass = true;
		},
	},
}
</script>

<style lang="scss">
@import '~@/assets/scss/common';
$result-table-expand-md-icon: plus-circle !default;
$result-table-expand-md-icon-closed: minus-circle !default;
$transition-collapse: height 0.35s ease !default;

.results-width-no-headvisual-layout {
	.page--wrapper {
		@include media-breakpoint-down(md) {
			margin-top: 0;
		}
	}
}

.result-table-overview {
	position: relative;
}

.loading-container {
	position: absolute;
	width: 100%;
	height: 100%;
	background: #ffffffab;
	left: 0;
	right: 0;
	z-index: 99999;
	padding: 1rem;
	text-align: center;
	color: $primary;
	@include responsive-type(1, 1);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.loading {
	display: inline-block;
	width: 1.8rem;
	height: 1.8rem;
	border: 3px solid $tertiary;
	border-radius: 50%;
	border-top-color: #00af84;
	animation: spin 1s ease-in-out infinite;
	margin-bottom: 10px;
}

@keyframes spin {
	to {
		-webkit-transform: rotate(360deg);
	}
}

.result-table-overview {
	.result-table-item-header-job {
		color: $primary;
		@include responsive-type(4, 1);
		font-weight: $font-weight-bold;
	}

	.center-wrapper {
		@include media-breakpoint-down(md) {
			width: 100%;

			p {
				max-width: 90%;
			}
		}
	}

	.result-table-cell {
		padding: 20px 0;

		@include media-breakpoint-up(md) {
			padding: 40px 0;
		}
	}

	.result-table-row {
		padding: 0;
	}

	.btn-apply {
		@include media-breakpoint-down(md) {
			margin-bottom: unit(4);
		}
	}
}

.result-table-overview .sm-flex-column {
	@include media-breakpoint-down(md) {
		flex-direction: column;
	}
}

.result-table-overview .sm-no-border {
	@include media-breakpoint-down(md) {
		border-bottom: 0;
	}
}

.result-table-expand {
	@each $breakpoint in map-keys($grid-breakpoints) {
		$next: breakpoint-next($breakpoint, $grid-breakpoints);
		$infix: breakpoint-infix($next, $grid-breakpoints);

		&#{$infix} {
			@include media-breakpoint-up($next) {
				.navbar-collapse {
					display: inline-block !important;
					transition: none;
				}
			}
		}
	}
}

.result-table-expand-md {
	.result-table-cell.collapsed {
		&:after {
			content: fa-content($fa-var-plus-circle);
			font-family: 'Font Awesome 5 Pro';
			@extend %fa-icon;
			color: $tertiary;
		}
	}

	.show {
		transition: $transition-collapse;
	}

	.result-table-cell.not-collapsed {
		&:after {
			content: fa-content($fa-var-minus-circle);
			font-family: 'Font Awesome 5 Pro';
			@extend %fa-icon;
			color: $tertiary;
			transform: rotate(-180deg);
		}

		pointer-events: none;

		@include media-breakpoint-down(md) {
			border-bottom: 0;
			pointer-events: all;
		}
	}

	.result-table-cell.collapsed:after,
	.result-table-cell.not-collapsed:after {
		@include media-breakpoint-up(md) {
			display: none;
		}
	}

	.json-html-list ul {
		padding-left: 18px;
		margin: 0;
	}
}
</style>
